import dayjs from 'dayjs';

/** Signature timestamps are stored as ISO-8601 UTC so audit times are unambiguous. */
export const createSignatureTimestamp = (date: Date = new Date()) => date.toISOString();

/** Display format, e.g. `10/07/2026 14:03:22 (UTC+05:30)`. Returns '' for missing/invalid input. */
export const formatSignatureTimestamp = (timestamp: string | Date) => {
  if (!timestamp) return '';
  const date = dayjs(timestamp);
  return date.isValid() ? date.format('MM/DD/YYYY HH:mm:ss [(UTC]Z[)]') : '';
};
